"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { getTimeAgo } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  slug?: string;
};
export default function HorizontalSmallNews(t0) {
  const $ = _c(27);
  const {
    title: t1,
    timeAgo: t2,
    slug
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? {
      hidden: false,
      value: "\u0B95\u0BB0\u0BCD\u0BA8\u0BBE\u0B9F\u0B95 \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BAE\u0BC7\u0B95\u0BCD\u0B95\u0BC7\u0BA4\u0BBE\u0B9F\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD \u0B95\u0BBE\u0BB5\u0BBF\u0BB0\u0BBF\u0BAF\u0BBF\u0BA9\u0BCD \u0B95\u0BC1\u0BB1\u0BC1\u0B95\u0BCD\u0B95\u0BC7 \u0B85\u0BA3\u0BC8 \u0B95\u0B9F\u0BCD\u0B9F\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BB5\u0BA4\u0BBE\u0BB2\u0BCD \u0BA4\u0BAE\u0BBF\u0BB4\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0B8E\u0BA8\u0BCD\u0BA4 \u0BAA\u0BBE\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1\u0BAE\u0BCD \u0B87\u0BB2\u0BCD\u0BB2\u0BC8 \u0B8E\u0BA9\u0BCD\u0BB1\u0BC1 \u0B95\u0BB0\u0BCD\u0BA8\u0BBE\u0B9F\u0B95 \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2 \u0BA4\u0BC1\u0BA3\u0BC8 \u0BAE\u0BC1\u0BA4\u0BB2\u0BAE\u0BC8\u0B9A\u0BCD\u0B9A\u0BB0\u0BCD \u0B9F\u0BBF.\u0B95\u0BC7. \u0B9A\u0BBF\u0BB5\u0B95\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD \u0B95\u0BC2\u0BB1\u0BBF\u0BAF\u0BBF\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0BA4\u0BC1 \u0B8F\u0BB1\u0BCD\u0BAA\u0BC1\u0B9F\u0BC8\u0BAF\u0BA4\u0BBE? \u0B8E\u0BA9\u0BCD\u0BB1 \u0B95\u0BC7\u0BB3\u0BCD\u0BB5\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BB5\u0BBE\u0B9A\u0B95\u0BB0\u0BCD\u0B95\u0BB3\u0BBF\u0B9F\u0BAE\u0BBF\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0BB5\u0BA8\u0BCD\u0BA4 \u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0B9A\u0BBF\u0BB2.",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const title = t3;
  let t4;
  if ($[2] !== t2) {
    t4 = t2 === undefined ? {
      hidden: false,
      value: "May 17, 2023",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const timeAgo = t4;
  const titleValue = title?.value || "";
  const t5 = timeAgo?.value;
  let t6;
  if ($[4] !== t5) {
    t6 = getTimeAgo(t5);
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const timeAgoValue = t6;
  let t7;
  if ($[6] !== title?.customClass || $[7] !== title?.hidden || $[8] !== titleValue) {
    t7 = !title?.hidden && <h3 className={`text-14-tamil-700 text-1B1B1B font-medium leading-[1.4] ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[6] = title?.customClass;
    $[7] = title?.hidden;
    $[8] = titleValue;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== timeAgo?.customClass || $[11] !== timeAgo?.hidden || $[12] !== timeAgoValue) {
    t8 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[10] = timeAgo?.customClass;
    $[11] = timeAgo?.hidden;
    $[12] = timeAgoValue;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = slug ? `/${slug}` : undefined;
  let t10;
  if ($[14] !== slug || $[15] !== t9 || $[16] !== titleValue) {
    t10 = <MessageIcon id="news-vert-message-icon" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} articleUrl={t9} />;
    $[14] = slug;
    $[15] = t9;
    $[16] = titleValue;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t8) {
    t11 = <div className="flex items-center justify-between">{t8}{t10}</div>;
    $[18] = t10;
    $[19] = t8;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t7) {
    t12 = <article className="p-4"><div className="flex gap-3"><div className="flex-1 min-w-0 flex flex-col gap-3">{t7}{t11}</div></div></article>;
    $[21] = t11;
    $[22] = t7;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const content = t12;
  if (slug) {
    const t13 = `/${slug}`;
    let t14;
    if ($[24] !== content || $[25] !== t13) {
      t14 = <Link href={t13} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[24] = content;
      $[25] = t13;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    return t14;
  }
  return content;
}